import { stripMarkdownFormatting } from '@/utils/stripMarkdownFormatting'

/**
 * Plain table cell text (no bold, italic, or inline markdown).
 * @param {{ text: string }} props
 */
export default function TableCellMarkdown({ text }) {
  const value = stripMarkdownFormatting(text)
  if (!value.trim()) return null
  return <span>{value}</span>
}
